export default __webpack_public_path__ + "static/media/u.0a1d89a1.svg";